'use strict'

const processInclude = require("base/js/util");
const pdpAddToCartUX = require("./experience/components/pdp/pdpAddToCartUX");

$(document).ready(() => {
  processInclude(pdpAddToCartUX);
});